import Calendar from '../../../collection/calendar';
import View from './../../view';

import { pst, } from '../../../http/api';
import { fmt } from '../../../utils/date';
import { Collection } from 'backbone';
import { hashify } from '../../../utils/arrays';





export default View.extend( {

    initialize(options = {}) {
        View.prototype.initialize.call( this, options );

        this.options.calendar = new Calendar( options.month );
    },

    template: 'module/schedule.preview',

    serialize() {
        const { attrs, calendar } = this.options;

        const url = `/timetables${attrs.id ? '/' + attrs.id : ''}/preview/${fmt( calendar.getMonth(), 'YYYY-MM' )}?apiVersion=2.0`;
        return pst( url ).cerebellum()
            .body( this.options.attrs )
            .execute()
            .then( ({ runs, holidays }) => {
                holidays = hashify( holidays );
                const runTimesByDate = hashify( runs, ({ date, time }, hash) =>
                    [date, [...(hash[date] || []), time]] );
                    
                return {
                    dates: new Collection( 
                        [...Object.keys( runTimesByDate ), ...Object.keys( holidays )]
                            .map( date => ({
                                date,
                                times: runTimesByDate[date] || [],
                                holiday: holidays[date]
                            }) ) )
                };
            } );
    },

    [View.event( 'preview:set-month' )](month) {
        return this.options.calendar.set( month ),
            this.enable( false ),
            this.render().then( () => this.enable( true ) );
    },

} );


// WEBPACK FOOTER //
// ./src/js/view/module/schedule/preview.js